import Reflux from "reflux";

const exported = {
    loadStoreInformation: Reflux.createAction("loadStoreInformation") as RefluxAction<[]>
};

export default exported;

export const { loadStoreInformation } = exported;
